import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import DeviceManager from '../../components/Devices/DeviceManager'

const Devices = () => {
  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, bgcolor: 'background.paper', boxShadow: 3 }}>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight="bold">
            Device Management
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Manage and monitor all registered devices across the system
          </Typography>
        </Box>
        <DeviceManager />
      </Paper>
    </Box>
  )
}

export default Devices